import Grid from 'apollo-react/components/Grid';
import Typography from 'apollo-react/components/Typography';
import React from 'react';

import Layout from './Layout';
import LazyText from './LazyText';
import PageContainer from './PageContainer';

const DefaultPageLayout = ({ pageTitle = '', removeHeaderMargin, children, ActionButton }) => {
  return (
    <Layout>
      <PageContainer>
        <Grid container spacing={1}>
          <Grid item xs={ActionButton ? 9 : 12}>
            <LazyText text={pageTitle}>
              <Typography variant="h2" style={{ marginBottom: removeHeaderMargin ? 0 : 12 }}>
                {pageTitle}
              </Typography>
            </LazyText>
          </Grid>
          {ActionButton && (
            <Grid item xs={3} style={{ textAlign: 'right', padding: 0 }}>
              {ActionButton}
            </Grid>
          )}
          <Grid item xs={12}>
            {children}
          </Grid>
        </Grid>
      </PageContainer>
    </Layout>
  );
};

export default DefaultPageLayout;
